import NiceModal from "@ebay/nice-modal-react";
import React, { useRef } from "react";
import { useController, useFormContext, useWatch } from "react-hook-form";

import btnDel from "assets/images/btn_del.png";
import { File as FileType } from "types/types";
import ButtonSmall from "./ButtonSmall";
import SimpleModal from "./modals/SimpleModal";
import { fileUrl } from "utils/utils";

const FilesField = ({ required }: { required?: boolean }) => {
  const fileRef = useRef<HTMLInputElement>(null);
  const { field } = useController({
    name: "files",
    rules: { required },
    defaultValue: [],
  });
  const oldFiles: FileType[] | undefined = useWatch({ name: "oldFiles" });
  const { setValue } = useFormContext();

  const onImportFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files?.length) {
      return;
    }
    const filesValues: File[] = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      filesValues.push(file);
      if (file.size / 1024 / 1024 > 100) {
        NiceModal.show(SimpleModal, {
          title: "알림",
          message: "100MB 이하 파일만 업로드 가능합니다.",
          showCancel: false,
        });
        return;
      }
    }

    field.onChange([...field.value, ...filesValues]);

    event.target.value = "";
  };

  const onDelete = (index: number) => {
    field.onChange(field.value.filter((file: File, i: number) => i !== index));
  };

  const onDeleteOld = (index: number) => {
    setValue(
      "oldFiles",
      oldFiles?.filter((file: FileType, i: number) => i !== index),
    );
  };

  return (
    <div className="flex flex-col gap-[0.313rem] py-[0.438rem]">
      <div>
        <input
          className="hidden"
          type="file"
          ref={fileRef}
          onChange={onImportFiles}
        />
        <ButtonSmall
          disabled={field.value.length >= 5}
          onClick={() => fileRef.current?.click()}
          className="w-20"
        >
          파일 첨부
        </ButtonSmall>
      </div>
      {!!oldFiles?.length && (
        <div className="flex flex-col">
          {oldFiles.map((file: FileType, index: number) => (
            <div key={file.fileno} className="flex items-center gap-5 text-12">
              <button type="button" onClick={() => onDeleteOld(index)}>
                <img
                  className="size-[11px]"
                  src={btnDel}
                  alt="삭제"
                  loading="lazy"
                />
              </button>
              <a
                href={`${fileUrl}=${file.filename}&uploadFileName=${encodeURI(encodeURI(file.upldfilename))}&filePath=${file.filepath}&disp=attachment`}
                target="_blank"
                rel="noreferrer"
                className="text-primary font-medium line-clamp-1 break-all"
              >
                {file.upldfilename}
              </a>
            </div>
          ))}
        </div>
      )}
      {!!field.value.length && (
        <div className="flex flex-col">
          {field.value.map((file: File, index: number) => (
            <div key={index} className="flex items-center gap-5 text-12">
              <button type="button" onClick={() => onDelete(index)}>
                <img
                  className="size-[11px]"
                  src={btnDel}
                  alt="삭제"
                  loading="lazy"
                />
              </button>
              <span>{file.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilesField;
